import EmptyResult from '../others/EmptyResult';
import ClientTableRow from './ClientTableRow';

interface ClientsTableBodyProps {
    clientsList: any[];
    fetchClients: (force?: boolean) => Promise<void>;
    setEditClientId: (clientId: number) => void;
    setInfoClientId: (clientId: number) => void;
}

const ClientsTableBody = ({
    clientsList,
    fetchClients,
    setEditClientId,
    setInfoClientId,
}: ClientsTableBodyProps) => {
    return (
        <tbody>
            {clientsList?.map((client) => (
                <ClientTableRow
                    key={client.ID}
                    client={client}
                    fetchClients={fetchClients}
                    setEditClientId={setEditClientId}
                    setInfoClientId={setInfoClientId}
                />
            ))}

            {clientsList.length === 0 && (
                <tr>
                    <td colSpan={6}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ClientsTableBody;
